export default __webpack_public_path__ + "static/media/copy.d2da8f7e.svg";